/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_ConnectInputs */

const cs_listing_portals_connect = /** @type {(inputs: Listing_Portals_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojit`)
};

const en_listing_portals_connect = /** @type {(inputs: Listing_Portals_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Listing_Portals_ConnectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_connect = /** @type {((inputs?: Listing_Portals_ConnectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_ConnectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_connect(inputs)
	return cs_listing_portals_connect(inputs)
});